module.exports = __webpack_public_path__ + "static/media/cat.72907d26.gif";